
import React, { useState } from "react";
import { FaCopy } from "react-icons/fa";
import JSONPretty from "react-json-pretty";
import "react-json-pretty/themes/monikai.css"; // JSONPretty theme
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const LocalBusinessSchemaForm = () => {
  const [formData, setFormData] = useState({
    businessType: "LocalBusiness",
    specificType: "",
    name: "",
    image: "",
    id: "",
    url: "",
    phone: "",
    priceRange: "",
    streetAddress: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
    latitude: "",
    longitude: "",
    open247: false,
    socialProfiles: [],
    openingHours: [],
    departments: [],
  });



  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const addOpeningHour = () => {
    setFormData({ ...formData, openingHours: [...formData.openingHours, ""] });
  };

  const handleOpeningHourChange = (index, value) => {
    const updatedHours = formData.openingHours.map((hour, i) =>
      i === index ? value : hour
    );
    setFormData({ ...formData, openingHours: updatedHours });
  };

  const removeOpeningHour = (index) => {
    setFormData({
      ...formData,
      openingHours: formData.openingHours.filter((_, i) => i !== index),
    });
  };

  const addDepartment = () => {
    setFormData({
      ...formData,
      departments: [...formData.departments, { name: "", url: "" }],
    });
  };

  const handleDepartmentChange = (index, field, value) => {
    const updatedDepartments = formData.departments.map((dept, i) =>
      i === index ? { ...dept, [field]: value } : dept
    );
    setFormData({ ...formData, departments: updatedDepartments });
  };

  const removeDepartment = (index) => {
    setFormData({
      ...formData,
      departments: formData.departments.filter((_, i) => i !== index),
    });
  };

  const addSocialProfile = () => {
    setFormData({
      ...formData,
      socialProfiles: [...formData.socialProfiles, ""],
    });
  };

  const handleSocialProfileChange = (index, value) => {
    const updatedProfiles = formData.socialProfiles.map((profile, i) =>
      i === index ? value : profile
    );
    setFormData({ ...formData, socialProfiles: updatedProfiles });
  };

  const removeSocialProfile = (index) => {
    setFormData({
      ...formData,
      socialProfiles: formData.socialProfiles.filter((_, i) => i !== index),
    });
  };


  const generateSchema = () => {
    return {
      "@context": "https://schema.org",
      "@type": formData.businessType,
      "name": formData.name,
      "image": formData.image,
      "@id": formData.id,
      "url": formData.url,
      "telephone": formData.phone,
      "priceRange": formData.priceRange,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": formData.streetAddress,
        "addressLocality": formData.city,
        "addressRegion": formData.state,
        "postalCode": formData.postalCode,
        "addressCountry": formData.country,
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": formData.latitude,
        "longitude": formData.longitude,
      },
      "openingHours": formData.openingHours,
      "department": formData.departments.map((dept) => ({
        "@type": "LocalBusiness",
        "name": dept.name,
        "url": dept.url,
      })),
      "sameAs": formData.socialProfiles,
      "additionalProperty": formData.open247
        ? {
            "@type": "PropertyValue",
            "name": "Open 24/7",
            "value": "true",
          }
        : undefined,
    };
  };
  const [schema, setSchema] = useState({
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "",
    "image": "",
    "@id": "",
    "url": "",
    "telephone": "",
    "priceRange": "",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "",
      "addressLocality": "",
      "addressRegion": "",
      "postalCode": "",
      "addressCountry": ""
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "",
      "longitude": ""
    },
    "openingHours": [],
    "department": [],
    "sameAs": []
  });
  
  const handleSubmit = (e) => {
    e.preventDefault();
    const generatedSchema = generateSchema();
    setSchema(generatedSchema);
    toast.success("Schema generated successfully!");
  };

  const copyToClipboard = () => {
    if (schema) {
      navigator.clipboard.writeText(JSON.stringify(schema, null, 2)).then(() => {
        toast.info("JSON-LD copied to clipboard!");
      });
    } else {
      toast.error("Nothing to copy. Please generate the schema first.");
    }
  };
  const deleteSchema = () => {
    setSchema({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "",
      "image": "",
      "@id": "",
      "url": "",
      "telephone": "",
      "priceRange": "",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "",
        "addressLocality": "",
        "addressRegion": "",
        "postalCode": "",
        "addressCountry": ""
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "",
        "longitude": ""
      },
      "openingHours": [],
      "department": [],
      "sameAs": []
    });
    toast.warning("Schema reset to dummy data!");
  };
  
  
  return (
    <div className="container mt-4">
      <ToastContainer />
      <h3 className="text-center mb-4">Local Business Schema Generator</h3>
      <div className="row">
        {/* Form Section */}
        <div className="col-lg-6 mb-4">
          <div className="card shadow-sm p-4">
            <h5 className="card-title text-center mb-4">Enter Business Details</h5>
            <form onSubmit={handleSubmit}>
              {/* Business Type */}
              <div className="mb-3">
                <label className="form-label">Business Type</label>
                <select
                  name="businessType"
                  className="form-select"
                  value={formData.businessType}
                  onChange={handleInputChange}
                >
                  <option value="LocalBusiness">LocalBusiness</option>
                  <option value="Restaurant">Restaurant</option>
                  <option value="Store">Store</option>
                </select>
              </div>
              <label className="form-label">More specific @type</label>
            <input
              type="text"
              className="form-control"
              name="specificType"
              value={formData.specificType}
              onChange={handleInputChange}
              placeholder="e.g., Bakery, Pharmacy"
            />
           {/* Name, Image, and URL */}
        <div className="row mb-3">
          <div className="col-md-4">
            <label className="form-label">Name</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter business name"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Image URL</label>
            <input
              type="text"
              className="form-control"
              name="image"
              value={formData.image}
              onChange={handleInputChange}
              placeholder="Enter image URL"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">@id (URL)</label>
            <input
              type="text"
              className="form-control"
              name="id"
              value={formData.id}
              onChange={handleInputChange}
              placeholder="Enter unique URL"
            />
          </div>
        </div>

        {/* Contact Information */}
        <div className="row mb-3">
          <div className="col-md-4">
            <label className="form-label">URL</label>
            <input
              type="text"
              className="form-control"
              name="url"
              value={formData.url}
              onChange={handleInputChange}
              placeholder="Enter website URL"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Phone</label>
            <input
              type="text"
              className="form-control"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              placeholder="Enter phone number"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Price Range</label>
            <input
              type="text"
              className="form-control"
              name="priceRange"
              value={formData.priceRange}
              onChange={handleInputChange}
              placeholder="e.g., $$, $$$"
            />
          </div>
        </div>

        {/* Address */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Street</label>
            <input
              type="text"
              className="form-control"
              name="streetAddress"
              value={formData.streetAddress}
              onChange={handleInputChange}
              placeholder="Enter street address"
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">City</label>
            <input
              type="text"
              className="form-control"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
              placeholder="Enter city"
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">Zip Code</label>
            <input
              type="text"
              className="form-control"
              name="postalCode"
              value={formData.postalCode}
              onChange={handleInputChange}
              placeholder="Enter zip code"
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-4">
            <label className="form-label">Country</label>
            <input
              type="text"
              className="form-control"
              name="country"
              value={formData.country}
              onChange={handleInputChange}
              placeholder="Enter country"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">State/Province</label>
            <input
              type="text"
              className="form-control"
              name="state"
              value={formData.state}
              onChange={handleInputChange}
              placeholder="Enter state/province"
            />
          </div>
        </div>

        {/* Geo-coordinates */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Latitude</label>
            <input
              type="text"
              className="form-control"
              name="latitude"
              value={formData.latitude}
              onChange={handleInputChange}
              placeholder="Enter latitude"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Longitude</label>
            <input
              type="text"
              className="form-control"
              name="longitude"
              value={formData.longitude}
              onChange={handleInputChange}
              placeholder="Enter longitude"
            />
          </div>
        </div>

        {/* Open 24/7 */}
        <div className="mb-3">
          <label>
            <input
              type="checkbox"
              name="open247"
              checked={formData.open247}
              onChange={handleInputChange}
            />
            &nbsp; Open 24/7
          </label>
        </div>
        {/* Social Profiles */}
        <div className="mb-3">
          <label className="form-label">Social Profiles</label>
          {formData.socialProfiles.map((profile, index) => (
            <div key={index} className="row align-items-end mb-2">
              <div className="col-md-10">
                <input
                  type="text"
                  className="form-control"
                  value={profile}
                  onChange={(e) => handleSocialProfileChange(index, e.target.value)}
                  placeholder="Enter social profile URL"
                />
              </div>
              <div className="col-md-2 text-end">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => removeSocialProfile(index)}
                >
                  ✖
                </button>
              </div>
            </div>
          ))}
          <button type="button" className="btn btn-primary" onClick={addSocialProfile}>
            + Add Social Profile
          </button>
        </div>

        {/* Opening Hours */}
        <div className="mb-3">
          <label className="form-label">Opening Hours</label>
          {formData.openingHours.map((hour, index) => (
            <div key={index} className="row align-items-end mb-2">
              <div className="col-md-10">
                <input
                  type="text"
                  className="form-control"
                  value={hour}
                  onChange={(e) => handleOpeningHourChange(index, e.target.value)}
                  placeholder="Enter opening hour (e.g., Mo-Fr 09:00-17:00)"
                />
              </div>
              <div className="col-md-2 text-end">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => removeOpeningHour(index)}
                >
                  ✖
                </button>
              </div>
            </div>
          ))}
          <button type="button" className="btn btn-primary" onClick={addOpeningHour}>
            + Add Opening Hour
          </button>
        </div>

        {/* Departments */}
        <div className="mb-3">
          <label className="form-label">Departments</label>
          {formData.departments.map((dept, index) => (
            <div key={index} className="row align-items-end mb-2">
              <div className="col-md-5">
                <input
                  type="text"
                  className="form-control"
                  value={dept.name}
                  onChange={(e) =>
                    handleDepartmentChange(index, "name", e.target.value)
                  }
                  placeholder="Enter department name"
                />
              </div>
              <div className="col-md-5">
                <input
                  type="text"
                  className="form-control"
                  value={dept.url}
                  onChange={(e) => handleDepartmentChange(index, "url", e.target.value)}
                  placeholder="Enter department URL"
                />
              </div>
              <div className="col-md-2 text-end">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => removeDepartment(index)}
                >
                  ✖
                </button>
              </div>
            </div>
          ))}
          <button type="button" className="btn btn-primary" onClick={addDepartment}>
            + Add Department
          </button>
        </div>

              {/* Submit Button */}
              <div className="mt-4 text-center">
                <button type="submit" className="btn btn-primary w-100">
                  Generate Schema
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* JSON-LD Preview Section */}
        <div className="col-lg-6">
          <div className="card shadow-sm p-4">
            <h5 className="card-title text-center mb-4">Generated JSON-LD</h5>
            <div className="d-flex justify-content-center align-items-center mb-3 mt-3">
  <button className="btn btn-primary me-2" onClick={copyToClipboard}>
    Copy
  </button>
  <button className="btn btn-danger me-2" onClick={deleteSchema}>
    Reset
  </button>
  <button className="btn btn-info me-2">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://developers.google.com/search/docs/appearance/structured-data"
    >
      Validate
    </a>
  </button>
  <button className="btn btn-success">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://search.google.com/test/rich-results"
    >
      Test
    </a>
  </button>
</div>
            {schema ? (
              <div className="position-relative">
                <JSONPretty
                  id="json-pretty"
                  data={schema}
                  className="bg-light p-3 rounded border"
                  style={{ overflowX: "auto" }}
                ></JSONPretty>
              
              </div>
            ) : (
              <p className="text-center">No schema generated yet.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocalBusinessSchemaForm;
